import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function Testimoni({ data }) {
  return (
    <section className="w-full flex flex-col">
      <img
        src="/images/line-1.png"
        className="-md:hidden"
        alt="Line Horizontal"
      />
      <img
        src="/images/line-2.png"
        className="md:hidden"
        alt="Line Horizontal"
      />
      <ScrollAnimation animateOnce={true} animateIn="fadeInLeft">
        <div className="mt-20 container md:px-20 flex flex-col">
          <h1 className="text-6xl -md:text-3xl text-purple italic font-black">
            {data.title}
          </h1>
          <div className="flex items-center space-x-4">
            <h1 className="text-6xl -md:text-3xl text-purple italic font-black">
              {data.subtitle}
            </h1>
            <div className="bg-yellow md:w-110 md:h-4 -md:w-20 -md:h-2"></div>
          </div>
        </div>
      </ScrollAnimation>
      <div className="md:mt-32 -md:mt-10">
        {data.items.map((item, i) => (
          <div
            key={i}
            className="container md:px-20 md:space-x-16 flex justify-center items-center -md:pb-20"
          >
            <div className="w-8/12">
              <ScrollAnimation
                animateOnce={true}
                className="flex flex-col"
                animateIn="fadeInLeft"
              >
                <span className="text-9xl -md:text-5xl font-black text-yellow">
                  “
                </span>
                <p
                  className="text-2xl -md:text-xs -mt-4 font-medium"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}
                />
                <div className="mt-5">
                  <h3 className="font-extrabold text-purple text-3xl -md:text-xs">
                    {item.name}
                  </h3>
                  <p className="text-purple font-semibold text-2xl -md:text-xs">
                    {item.profesi}
                  </p>
                  <p className="text-purple font-semibold text-2xl -md:text-xs">
                    {item.alumni}
                  </p>
                </div>
                <span className="text-9xl -md:text-5xl font-black text-yellow text-right">
                  ”
                </span>
              </ScrollAnimation>
            </div>
            <div className="w-4/12 -md:ml-auto">
              <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
                <img src={item.image} alt="alumni" />
              </ScrollAnimation>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
